export type ErrorKind = 'JS' | 'CONSOLE' | 'NETWORK' | 'CRASH';

export const KIND_COLOR: Record<ErrorKind, string> = {
  JS: '#ef4444',
  CONSOLE: '#f59e0b',
  NETWORK: '#3b82f6',
  // A native crash killed the app — the most severe thing in the inbox.
  CRASH: '#a21caf',
};

export const STATUS_OPTIONS = ['OPEN', 'RESOLVED', 'IGNORED'] as const;
